import React, { FC, ButtonHTMLAttributes, useState, useEffect } from "react";
import { ArrowUpIcon } from "@heroicons/react/outline";
import Scroll from "react-scroll";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  sizeClass?: string;
}

const ButtonTop: FC<ButtonProps> = ({ sizeClass = "w-16 h-16", ...args }) => {
  const scroll = Scroll.animateScroll;
  const [top, setTop] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 1100) {
          setTop(false);
        } else {
          setTop(true);
        }
      });
    };
    onScroll();
    return window.removeEventListener("scroll", () => setTop(top));
  });
  return (
    <button
      onClick={() => {
        scroll.scrollToTop({ duration: 1500, delay: 100, smooth: true });
      }}
      className={`fixed z-20 hidden lg:flex items-center justify-center bg-primary-6000 dark:bg-primary-6000 right-10 bottom-10 shadow-lg rounded-full ${sizeClass} ${
        top && "hidden lg:hidden"
      } `}
      {...args}
    >
      <ArrowUpIcon className="w-8 h-8 text-white "></ArrowUpIcon>
    </button>
  );
};

export default ButtonTop;
